// 
export const BUCKET_ORGS = "agbase_orgs"
export const BUCKET_DEALS = "deals"